import { Component, DestroyRef, OnDestroy, OnInit, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NgForm } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import * as fromRoot from '../../app/store/reducers/index';
import { Auth } from '../interfaces/auth';
import { IAuthError, TrySignin, getAuthErrors, isAnonymous } from '../store/index';

@Component({
  selector: 'signin',
  templateUrl: './signin.component.html',
  standalone: false,
})
export class SigninComponent implements OnInit, OnDestroy {
  returnUrl: string = '';
  public loading$: Observable<boolean>;
  public isAnonymous$: Observable<boolean>;
  public errors$: Observable<IAuthError[]>; //errors for signin come back in a unique way
  destroyRef = inject(DestroyRef);

  constructor(
    public activeRoute: ActivatedRoute,
    public rootStore: Store<fromRoot.IState>
  ) {}

  public onSignin(form: NgForm) {
    const authData = new Auth(form.value.userName, form.value.password);
    if (this.returnUrl === undefined || this.returnUrl === null) {
      this.returnUrl = '/';
    }
    authData.returnUrl = this.returnUrl;
    this.rootStore.dispatch(new TrySignin({ authData }));
  }
  ngOnInit() {
    this.activeRoute.params.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((params) => {
      this.returnUrl = params['returnUrl'];
    });

    this.isAnonymous$ = this.rootStore.pipe(select(isAnonymous));

    this.loading$ = this.rootStore.pipe(
      select((state: fromRoot.IState) => state.loadingIndicator),
      filter((x) => x.requestor === 'auth'),
      map((x) => x.show)
    );

    //if login is successful, will route to home page from auth effects, just capture errors here
    this.errors$ = this.rootStore.pipe(select(getAuthErrors));
  }

  public ngOnDestroy(): void {
    // No manual unsubscribe needed when using takeUntilDestroyed
  }
}
